"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackLink = exports.trackView = void 0;
/**
 * Initiates the tracking of a page view
 *
 * @category Tealium Adapter
 *
 * @param dataObject the data object to be pushed to tealium
 * @param restrictedUids array of tag uids tealium should load
 * @returns a promise that resolves when the tracking has been completed
 * */
const trackView = (dataObject, restrictedUids) => {
    return new Promise(resolve => {
        if (typeof window !== 'undefined' && window.utag) {
            restrictedUids
                ? window.utag.view(dataObject, resolve, restrictedUids)
                : window.utag.view(dataObject, resolve);
        }
        else {
            resolve();
        }
    });
};
exports.trackView = trackView;
/**
 * Initiate the tracking of a non-page view
 *
 * @category Tealium Adapter
 *
 * @param dataObject the data object to be pushed to tealium
 * @param restrictedUids array of tag uids tealium should load
 * @returns a promise that resolves when the tracking has been completed
 * */
const trackLink = (dataObject, restrictedUids) => {
    return new Promise(resolve => {
        if (typeof window !== 'undefined' && window.utag) {
            restrictedUids
                ? window.utag.link(dataObject, resolve, restrictedUids)
                : window.utag.link(dataObject, resolve);
        }
        else {
            resolve();
        }
    });
};
exports.trackLink = trackLink;
